<template>
 
  <div class="space-y-6">
    <!-- Modales -->
     
    <ModalIngresoMes
      :borrador="borrador"
      :nomcta="nomcta"
      :nomcentro="nomcentro"
      :visible="visibleIngreso"
      :mes="mes"
      :datosIngreso="datosIngreso"
      :ingresos_bloqueados="ingresos_bloqueados"
      @update:visible="visibleIngreso = $event"
      @get_monto_mensual="set_monto_mensual"
    />

    <ModalModificacionMes
      :borrador="borrador"
      :centro_id="centro_id"
      :nomcentro="nomcentro"
      :nomcta="nomcta"
      :visible="visibleModificacion"
      :datosModificacion="datosModificacion"
      :timestamp="timestamp"
      :modificaciones_bloqueados="modificaciones_bloqueados"
      @update:visible="visibleModificacion = $event"
      @get_monto_mensual="set_monto_mensual"
      @recarga_presupuestos_mensuales="llenavalores"/>

    <ModalTiposModificacion
      :visible="visibleTipoModificacion"
      :datos="datos"
      @update:visible="visibleTipoModificacion = $event"
      @get_tipo_modif="set_tipo_modif"/>

    <ModalHistorial
      :visible="visibleHistorial"
      @update:visible="visibleHistorial = $event"
      :datos="datos_historial"
      @recarga_presupuestos_mensuales="llenavalores"/>
    
    <!-- Total 
    <div class="text-gray-900 font-medium mb-4">
      
      <span class="text-gray-900 font-medium">{{ total_presupuesto }}</span>
    </div>-->

    <!-- Título sección -->
    <div class="flex justify-between">
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&lt;IngresosMensuales&gt;</span>
      <span class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">/api/v1/ingresos/presupuesto/centro/x/cuenta/y/</span>
    </div>
 
   
    
    <!-- Contenedor principal -->
    <div class="p-5 rounded-b-xl shadow-md transition-all duration-300"
      :class="borrador 
        ? 'bg-gradient-to-br from-green-50 to-emerald-50 border border-green-500' 
        : 'bg-white border border-gray-200'">
     
     <div class="flex justify-start ">
      <!-- Grilla de ingresos -->
       <div class="grid grid-cols-1 grid-rows-7   gap-1 w-30 text-sm font-mono mt-1 mr-2">
        <div class="pt-2">Mes</div>
        <div class="pt-2">Ingreso</div>
        <div class="pt-0">Aumentos</div>
        <div  class="">Disminuciones</div>
        <div  class="mt-3">Total</div>
        <div  class="text-white h-6">*</div><div class="text-white">*</div>
      </div>
      <div class="grid grid-cols-12 grid-rows-2 gap-2 w-full text-sm font-mono ml-2 ">
     
       
        <!-- Fila 1: Meses -->

        <div  v-for="(nombre, index) in meses"  :key="index" class="col-span-1 px-2 py-2 text-center rounded-lg cursor-pointer font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 transition shadow-sm">
          {{ nombre }}
        </div>
        
        <!-- Fila 2: ingresos -->
        <div   v-for="mes in 12"  :key="'fila2-' + mes"  class="col-span-1 px-2 py-2 text-center rounded-lg cursor-pointer bg-gray-100 text-green-800 hover:bg-green-200 transition shadow-sm">
         
          <div v-if="loading" class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

          <span class="text-sm font-mono" v-else>
            {{ $formatoMiles(monto_mensual[mes]) }}
          </span>
        </div>
        <!-- Fila 3: modificaciones  suma-->
        <div
          v-for="mes in 12"
          :key="'fila3-' + mes"
          @click="showmodal_modificaciones( )"
          class="col-span-1 px-2 py-2 text-center rounded-lg cursor-pointer bg-gray-100 text-green-800 hover:bg-green-200 transition shadow-sm"
        >
          <div
            v-if="loading"
            class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"
          ></div>

          <span class="text-sm font-mono text-blue-700" v-else>
            + {{ $formatoMiles(this.monto_modif_mensual_suma[mes]) }}
          </span>
        </div>
        <!-- Fila 4: modificaciones  restas-->
        <div
          v-for="mes in 12"
          :key="'fila3-' + mes"
          @click="showmodal_modificaciones( )"
          class="col-span-1 px-2 py-2 text-center rounded-lg cursor-pointer bg-gray-100 text-green-800 hover:bg-green-200 transition shadow-sm">
          <div
            v-if="loading"
            class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

          <span class="text-sm font-mono text-red-800" v-else>
            - {{ $formatoMiles(this.monto_modif_mensual_resta[mes]) }}
          </span>

        </div>
        <!-- Fila 5: Presupuesto -->
        <div  v-for="mes in 12" :key="'fila5-' + mes"  class="col-span-1 px-2 py-2 text-center rounded-lg cursor-pointer bg-yellow-200 text-green-800 hover:bg-green-200 transition shadow-sm">
          <div  v-if="loading"  class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

          <span class="text-sm font-mono" v-else>  {{ $formatoMiles(this.presupuesto_mensual[mes]) }} </span>
           

        </div>
        <div v-for="mes in 12"  :key="'fila2-' + mes"  @click="showmodal(mes, this.presupuesto_mensual[mes])" class="col-span-1  mt-3 text-center rounded-sm cursor-pointer  hover:bg-indigo-500 hover:text-white transition shadow-sm">
          <div v-if="loading"  class="w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
          <span class="text-sm font-mono" v-else> <a class="btn btn-info text-sm font-mono p-4">Modificar</a>  </span>
        </div>
        <div v-for="mes in 12" :key="'fila2-' + mes"  @click="showmodalHistorial(mes, this.presupuesto_mensual[mes])"
          class="col-span-1   text-center rounded-sm cursor-pointer   hover:bg-indigo-500  hover:text-white transition shadow-sm mt-3">
         
          <div  v-if="loading"  class=" rounded-sm cursor-pointer w-6 h-6 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

          <span class="text-sm font-mono  " v-else> Historial </span>
          
        </div>
      </div>
    </div>
      <!-- Candado -->
      <div class="mt-4 flex items-center space-x-2">
      
        <div v-if="ingresos_bloqueados">
          <a @click="candado(false)" class="cursor-pointer inline-block">
            <img
              src="images/padlock.png"
              class="w-7 h-7 hover:scale-110 transition"
            />
          </a>
        </div>

        <div v-else>
          <a @click="candado(true)" class="cursor-pointer inline-block">
            <img
              src="images/unlock.png"
              class="w-7 h-7 hover:scale-110 transition"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalIngresoMes from "./ModalIngresoMes.vue";
import ModalModificacionMes from "./ModalModificacionMes.vue";
import ModalTiposModificacion from "./ModalTiposModificacion.vue";
import ModalHistorial from "./ModalHistorial.vue";
import api from "@/api/axios";
import { useIngresos } from "@/composables/useIngresos";

export default {
  emits: ["toggleCuenta","getApiPresupuesto"],
  props: {
    nomcta: {
      type: String,
    },
    nomcentro: {
      type: String,
    },
    centro_id: {
      type: Number,
    },
    propCuenta_id: {
      type: Number,
    },

    datosFromModalIngreso: {
      type: Object,
    },
    componenteVisible: {
      type: Boolean,
    },
     propReloadMovimientosMensuales:{
      type:Number,
    },
    borrador:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      visibleIngreso: false,
      visibleModificacion: false,
      visibleTipoModificacion: false,
      ingresos: [],
      modificaciones:[],
      presupuesto_id: 0,
      ingresos_bloqueados: false,
      modificaciones_bloqueados: false,
      total_presupuesto: 0,
      mes: 0,
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Sept",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      monto_mensual: [],
      monto_modif_mensual_suma: [],
      monto_modif_mensual_resta: [],
      presupuesto_mensual: [],
      loading: true,
      dataModalIngreso: {},
      datosIngreso: {},
      datos: {},
      datos_historial:{},
      timestamp: "",
      visibleHistorial: false,
      datosModificacion:{},
      reloadMovimientosMensuales:'',
      polling:'',
      visibleModal:false,
      aa_consulta:0
    };
  },
  methods: {
    polldata() {
      this.polling = setInterval(() => {
     
          this.llenavalores();
     
        
      }, 10000);  
    },
    showmodal(mes, monto) {
      console.log(monto);
      this.mes = mes;
      if (!this.ingresos_bloqueados) {
        this.showmodalIngreso(mes);
      } else {
        this.datos = {
          nomcta: this.nomcta,
          nomcentro: this.nomcentro,
          nommes: this.meses[this.mes - 1],
          monto_mensual_ingreso: monto,
        };
        this.showmodalTipoModificacion();
      }
    },
    showmodal_todoenuno(mes, accion_id, reasignar, monto_modif) {
      if (!this.ingresos_bloqueados) {
        this.showmodalIngreso(mes);
      } else {
        this.showmodalModificacion(mes, accion_id, reasignar, monto_modif);
      }
    },
    showmodalIngreso(value) {
      this.mes = value;
      this.datosIngreso = this.ingresos.find((ing) => ing.mes == value);
      console.log("->", this.datosIngreso);
      if (typeof this.datosIngreso === "undefined") {
        console.log("indefinido");
        this.datosIngreso = {
          presupuesto_id: this.presupuesto_id,
          monto_mensual: "",
          glosa: "",
          mes: this.mes,
        };
      }
      this.visibleIngreso = true;
    },
    showmodalModificacion(mes, accion_id, reasignar, monto_modif) {
      this.mes = mes;

      this.datosModificacion = this.ingresos.find((ing) => ing.mes == mes);
      if (typeof this.datosModificacion === "undefined") {
        // significa que al mes no se le creó un registro de Ingreso.
        this.datosModificacion = {
          presupuesto_id: this.presupuesto_id,
          mes: this.mes,
          id: 0,
          monto_mensual_ingreso: 0,
        };
      }
      this.datosModificacion.accion_id = accion_id;
      this.datosModificacion.monto_modif = monto_modif;
      this.datosModificacion.reasignar = reasignar;
      this.datosModificacion.presupuesto_mensual =  this.presupuesto_mensual[mes];
      this.timestamp = new Date().toISOString().slice(0, 19).replace("T", " "); // crear string timestamp
      this.visibleModificacion = true;
    },
    showmodalTipoModificacion() {
      this.visibleTipoModificacion = true;
    },
    showmodal_modificaciones( ) {
          return true; 
    },
    showmodalHistorial(mes, monto) {
    
       this.datos_historial = {
          nomcta: this.nomcta,
          nomcentro: this.nomcentro,
          nommes: this.meses[this.mes - 1],
          monto_mensual_ingreso: monto,
          centro_id : this.centro_id,
          cuenta_id : this.cuenta_id,
          presupuesto_id:this.presupuesto_id,
          mes: mes,
          ingresos: this.ingresos,
          modificaciones: this.modificaciones
        };
        console.log(this.datos_historial.ingresos)
      this.visibleHistorial= true
    },
    async llenavalores() {
      if (!this.centro_id  || !this.cuenta_id ) {
        return false;
      }
    
      //let resp = await this.getIngresos(this.centro_id,this.cuenta_id)
      const { getIngresos } = useIngresos();
      const resp = await getIngresos(this.centro_id, this.cuenta_id,this.borrador);
      this.ingresos = resp.ingresos;
      this.modificaciones = resp.modificaciones;
      this.presupuesto_id = resp.presupuesto_id;
      this.ingresos_bloqueados = resp.ingresos_bloqueados;
      this.total_presupuesto = this.formatoMiles(resp.total_presupuesto);
      this.recalcular_totales(this.ingresos, this.modificaciones );

      this.$emit('getApiPresupuesto' )
      
    },

    recalcular_totales(ingresos, modificaciones)
    {
        // argumentos:
       // "ingresos": [  {  "id": 37,  "mes": 1, "monto_mensual": "120000.00",    "presupuesto_id": 1168 .... } 
       //"modificaciones": [  {   "mes": 1,  "tipo_modificacion": 1,  "monto": "1000.00" },
       //(pueden venir muchos registros con el campo mes repetido (muchas modificaciones en enero.))
      
      if (ingresos) {
       
        const mapa =
          ingresos && Array.isArray(ingresos)
            ? Object.fromEntries(
                ingresos.map((item) => [item.mes, item.monto_mensual])
              )
            : {};
        // mapa: {  "1": "120000.00",  "2": "120000.00", .....    
        for (let mes = 1; mes <= 12; mes++) {
          this.monto_mensual[mes] = mapa[mes] ? `${mapa[mes]}` : "";
          this.presupuesto_mensual[mes] = Number(this.monto_mensual[mes]);
        }
        this.loading = false;
      
  

     
      } else {
        console.error("no se leyeron ingresos");
        this.loading = false;
      }
    
     

      
      if (modificaciones) {
        //console.log("modificaciones", modificaciones);
        const modif_simple_suma = modificaciones.filter(
          (m) => m.tipo_modificacion === 1
        );
        const modif_simple_resta = modificaciones.filter(
          (m) => m.tipo_modificacion == 2
        );
     

        for (let mes = 1; mes <= 12; mes++) {
          /*
          reduce → suma todos los monto, Number(m.monto) → convierte "1000.00" → 1000, Si no hay datos → retorna 0
          */
          // console.log('array todas las sumas',modif_simple_suma)
          this.monto_modif_mensual_suma[mes]  = modif_simple_suma
            .filter((m) => m.mes == mes)
            .reduce((total, m) => total + Number(m.monto), 0);

          this.monto_modif_mensual_resta[mes]  = modif_simple_resta
            .filter((m) => m.mes == mes)
            .reduce((total, m) => total + Number(m.monto), 0);

            //console.log('calculo suma:', this.monto_modif_mensual_suma[mes]);
            this.presupuesto_mensual[mes]+= Number( this.monto_modif_mensual_suma[mes]);
           
            this.presupuesto_mensual[mes] -=  Number(this.monto_modif_mensual_resta[mes]);
           
        }


       
      } else {
        console.error("no se leyeron modificaciones");
        this.loading = false;
      }
    },

    set_monto_mensual() {
      console.log("recarga valores");
      this.llenavalores();
    },
    set_tipo_modif(obj) {
      let accion_id = obj.accion_id;
      let monto_modif = obj.monto_modif;
      let reasignar = obj.reasignar;
      // accion_id:  solo trae 1, 2 o 3
      //this.$emit("exit",{'accion':accion_id, 'cuenta_id': this.cuenta_id,'centro_id':this.centro_id, 'mes':this.mes });
      this.showmodal_todoenuno(this.mes, accion_id, reasignar, monto_modif);
    },
    async candado(estado) {
      try {
        const data = { presupuesto_id: this.presupuesto_id, estado: estado };
        const resp = await api.post(
          `/api/v1/presupuesto/ingresos/bloqueo/`,
          data,
          { headers: { "Content-Type": "application/json"  } }
        );
        const status = resp.data.status;
        switch (status) {
          case 200:
            console.log("actualizado");
            this.ingresos_bloqueados = estado;
            break;
          default:
            console.error("");
        }
        return true;
      } catch (err) {
        console.log(err);
      }
    },
    formatoMiles(num) {
      return Number(num).toLocaleString("es-CL", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
      });
    },
  },
  mounted() {
    //console.log("monta:", this.cuenta_id);
    this.cuenta_id = this.propCuenta_id;
  
    this.llenavalores();
    this.polldata();
  },
  components: {
    ModalIngresoMes,
    ModalModificacionMes,
    ModalTiposModificacion,
    ModalHistorial
  },
  watch: {
    componenteVisible: function (v) {
      if (v == true) {
        console.info("watch:", this.cuenta_id);
        this.llenavalores();
      }
    },
    propCuenta_id:function(v){
        this.cuenta_id = v;
      
    },
    datosFromModalIngreso: function () {},
     
  },
    beforeUnmount() {
    clearInterval(this.polling);
  },
};
</script>
